var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACUklEQVR4nO3dQU5TQQCH8U+lrBQT1rJW4RrqBYw30NsoSriFIa4Vj6EL41LXLCzsIMFF20Qltcy8Tv+Pvu+XzHJeZ+aDvpSQV5Akqa0d4AgYT8cH4GF0RX/r+/o62QFOgMt/xgnwILiumb6vr7Mjrm5uNt4H1zXT9/V1Nmb+Bn8F1zUTXd+t1i/AZCPpNfxPdH23W15cixkgzABhywiwB7wFvgJnXL2RLTLvBriqUbq+s+le94Hda8xvZhM4BC7IH2JqXAAHwKjjWRbbBD53WPi6jWNWHOGwwSZu+njX6UQL7DHst5154xx4XHqYNTfhV8CdinnrbgN4WTqpJsDTijlD8ax0Qs3H7FPgbsW8ITgFtkom1AS4rJgzJEVn6ifhMAOEGSDMAGEGCDNAmAHCDBBmgDADhBkgbKPBNdP/59PaUv8W5m9AmAHCDBBmgDADhBkgzABhBggzQJgBwgwQZoAwA4QZIMwAYQYIM0CYAcIMEGaAMAOEGSDMAGEGCDNAmAHCDBBmgDADhBkgzABhBggzQJgBwgwQZoAwA4QZIMwAYS0C3Gtwzb64v+wLtgjwpME1+6IXe1v0BNlvwHZsde1sA99ZvP/mrvMY35/ACwqfodlTW8Bzrnf4xQFqnuswZr3f57sYU3ifqLkH/KiYMxTFZ1MT4LhizlB8XMWL7OLj6+c9vv5Rh3MtcrCCDd20sd/pRAuNmLwVpTfdl/GJwPfIjJh8bcd5h4Xf9HHO5Cd/5Yf/p13gDfCFyfPz04fSepxO9/qaiq8skSRJkiRJ0nD9Bu8p7ScWyCcQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5b807141214551dd6ab1d8bfa59c473e.svg";
export { ForwardRef as ReactComponent };